import axios from 'axios';
import {interceptorResponse, interceptorError} from '@/helpers/interceptorResponse';

class API {

  async configure(){
    const api = axios.create({
      baseURL: `${process.env.VUE_APP_API_BASE_PROGNOZWEB}`,
      timeout: 60000
    });
    api.interceptors.request.use(this.authInterceptor);
    api.interceptors.response.use(
      interceptorResponse,
      interceptorError
    );
    return api;
  }
}

export default API;
